var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraAltBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.667-5.667h73.334v73.334H-5.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.444 6.556h-9.686L40.167.444H21.833l-5.591 6.112H6.556c-3.362 0-6.112 2.75-6.112 6.11v36.667c0 3.361 2.75 6.111 6.112 6.111h48.888c3.362 0 6.112-2.75 6.112-6.11V12.666c0-3.361-2.75-6.111-6.112-6.111zm0 42.777H6.556V12.667H18.93l5.591-6.111h12.956l5.591 6.11h12.375v36.667zM31 15.723c-8.433 0-15.278 6.844-15.278 15.277S22.567 46.278 31 46.278 46.278 39.433 46.278 31 39.433 15.722 31 15.722zm0 24.444c-5.042 0-9.167-4.125-9.167-9.167s4.125-9.167 9.167-9.167 9.167 4.125 9.167 9.167-4.125 9.167-9.167 9.167z",
    fill: "#232323",
    fillRule: "nonzero"
  }))));
}
export default SvgCameraAltBlack24Dp;